import gql from 'graphql-tag'
const { REACT_APP_PHOTOS_HAVE_USER_SUB: photosHaveUserSub } = window.APP_CONFIG

export const LIST_RESOURCE_IMAGES = gql`
    query listResourceImages($rootType: RootEntity, $rootId: String, $queryInput: QueryInput) {
        listResourceImages(rootType: $rootType, rootId: $rootId, queryInput: $queryInput) {
            items {
                createdAt
                deletedAt
                primary_key
                authorId
                metadata
                ${photosHaveUserSub === 'true' ? 'userSub' : '#userSub'}
                reactions
            }
            lastEvaluatedKey
        }
    }
`

export const FIND_USER_PHOTO = gql`
    query FindUserPhoto($primaryKey: String!) {
        findUserImage(primaryKey: $primaryKey) {
            createdAt
            deletedAt
            primary_key
            authorId
            metadata
            reactions
            ${photosHaveUserSub === 'true' ? 'userSub' : '#userSub'}
            nextImage {
                primary_key
            }
            previousImage {
                primary_key
            }
        }
    }
`

export const FIND_USER_REACTION = gql`
    query FindUserReaction($primaryKey: String!, $authorId: Int!) {
        findUserReaction(primaryKey: $primaryKey, authorId: $authorId) {
            authorId
            reactionId
        }
    }
`

export const LIST_IMAGE_REACTIONS = gql`
    query ListImageReactions($primaryKey: String!, $limit: Int, $nextToken: String) {
        listImageReactions(primaryKey: $primaryKey, limit: $limit, nextToken: $nextToken) {
            reactions {
                authorId
                metadata
            }
            nextToken
        }
    }
`

/**
 * Checks whether cognito user exists
 * @type {DocumentNode}
 */
export const COGNITO_USER_EXISTS = gql`
    query cognitoUserExists($email: String!) {
        cognitoUserExists(email: $email)
    }
`
